import React from 'react';
import { Menu } from 'antd';
import { ROUTES } from '../../routes';

export const TopNav: React.FC = () => {
  const menuItems = [
    {
      key: 'home',
      label: 'Home',
      onClick: () => { window.location.href = ROUTES.HOME; },
    },
    {
      key: 'data',
      label: 'Data',
      onClick: () => { window.location.href = ROUTES.DATA; },
    },
    {
      key: 'visual-aid',
      label: 'Visual Aid',
      children: [
        {
          key: 'production',
          label: 'Production',
          children: [
            {
              key: 'prod-geo',
              label: 'Geothermal',
              onClick: () => { window.location.href = ROUTES.PDGEOTHERMAL; },
            },
            {
              key: 'prod-oil',
              label: 'Oilfield',
              onClick: () => { window.location.href = ROUTES.PDOILFIELD; },
            },
          ],
        },
        {
          key: 'market-size',
          label: 'Market Size',
          children: [
            {
              key: 'wells-geo',
              label: 'Geothermal',
              onClick: () => { window.location.href = ROUTES.WELLSGEOTHERMAL; },
            },
            {
              key: 'wells-oil',
              label: 'Oilfield',
              onClick: () => { window.location.href = ROUTES.WELLSOILFIELD; },
            },
          ],
        },
        {
          key: 'nir',
          label: 'Net Import Reliance',
          onClick: () => { window.location.href = ROUTES.NIR; },
        },
      ],
    },
    {
      key: 'contribute',
      label: 'Contribute',
      onClick: () => { window.location.href = ROUTES.CONTRIBUTE; },
    },
    {
      key: 'references',
      label: 'References',
      onClick: () => { window.location.href = ROUTES.REFERENCES; },
    },
  ];

  return (
    <header className="topnav" style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
      {/* Utility strip */}
      <div className="topnav__util">
        <a href={ROUTES.HOME}>About</a>
        <a href={ROUTES.CONTRIBUTE}>Contact</a>
      </div>

      {/* Main header row */}
      <div
        style={{
          background: 'var(--navy)',
          display: 'flex',
          alignItems: 'center',
          padding: '0 24px',
          minHeight: 56,
        }}
      >
        <a className="topnav__logo" href={ROUTES.HOME}>
          GEOFLUID DATAHUB
        </a>
        <Menu
          theme="dark"
          mode="horizontal"
          items={menuItems}
          style={{
            background: 'transparent',
            flex: 1,
            justifyContent: 'flex-end',
            borderBottom: 'none',
            minWidth: 0,
          }}
          selectable={false}
        />
      </div>
    </header>
  );
};
